import { EventBus } from '../../vue/event_bus';

export const displayError = (err, msg = `Chyba při zpracovávání požadavku`) => {
	EventBus.$emit('showErrorMessage', { message: msg, is_error: true });
	console.error(err);
}
